class RootController {
    /**
     * @param {Object} userService
     */
    constructor($rootScope, $scope, $state, $location, userService) {
        let self = this;
        $scope.userService = userService;

        this.showPageAsForNonLogged = () => {
          return $location.path() === '/login' ||
              $location.path() === '/reset-password' ||
              $location.path() === '/forgot-password' ||
              $location.path().indexOf('/welcome') > -1 ||
              $location.path().match(/^\/client\//) !== null;
        };

        $rootScope.$on('$locationChangeSuccess', function(e, curr, prev) {
            // Hide loading message
            self.loadingView = false;
        });

        $rootScope.$on('$locationChangeStart', () => {
            // Show a loading message until promises aren't resolved
            self.loadingView = true;

            // redirect to login page if not logged in
            const notAuth = self.userIsNotAuthenticated();

            if(self.currentUser && !self.currentUser.name) {
                // $state.go('user.profile', {id: self.currentUser.id});
            } else if ($location.path() !== '/login' &&
                $location.path() !== '/reset-password' &&
                $location.path() !== '/forgot-password' &&
                $location.path().indexOf('/welcome') === -1 &&
                $location.path().match(/^\/client\//) === null && notAuth) {
                $location.path('/login');
            } else if (($location.path() === '/login' ||
                $location.path() === '/reset-password' ||
                $location.path() === '/forgot-password' ||
                $location.path().indexOf('/welcome') > -1) &&
                $location.path().match(/^\/client\//) !== null && !notAuth && userService.currentUser) {
                $location.path('/home');
            } else if ($location.path() === '/' && !notAuth && userService.currentUser) {
                $location.path('/home');
            } else if(!notAuth && !userService.currentUser) {
                userService.loadCurrentUser();
            }
        });

        $scope.$watch('userService.currentUser', function (newVal, oldVal, scope) {
            if (newVal) {
                self.currentUser = newVal;
        //         if(self.currentUser.username === self.currentUser.email || !self.currentUser.name) {
        //             $state.go('user.profile', {id: self.currentUser.id});
        //         }
                if ($state.current.name === 'root') {
                    $state.go('home');
                }
            }
        });

        this.userIsNotAuthenticated = function() {
            return !localStorage.getItem('kes_email') ||
                localStorage.getItem('kes_email') === 'undefined' ||
                !localStorage.getItem('kes_token') ||
                localStorage.getItem('kes_token') === 'undefined'
        };
    }

}

RootController.$inject = ['$rootScope', '$scope', '$state', '$location', 'UserService'];

export default RootController;



// WEBPACK FOOTER //
// ./src/app/root/rootController.js